import React, { useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Container, Row, Col, OverlayTrigger, Tooltip } from "react-bootstrap";

import "./CdGates.scss"

import messages from "../../assets/i18n";
import CdGateModal from "../../components/CdGateModal/CdGateModal";
import lodashTruncate from "../../utils/lodashTruncate";
import { ButtonStandard } from "../../components"

import VariationsModal from "../VariationsModal/VariationsModal"

function CdGates(props) {

	const dispatch = useDispatch();

	const lang = useSelector(state => state.language.name);
	const cdGateModal = useSelector(state => state.cdGates.cdGateModal);
	const cdId = useSelector(state => state.cdDetails.cdSelect);

	const { gates } = props;

	const [modalShowGate, setModalShowGate] = useState(false);

	const [modalVariations, setModalVariations] = useState(false);

	const editGate = ( idGate ) => {
		let objGate = ( gates.filter(gate => ( gate.id === idGate ) ) );

		changeGate( objGate && objGate[0] && objGate[0].horarios ? objGate[0] : [] );

		setModalShowGate(true)
	}

	const deleteGate = ( idGate ) => {
		let objGate = ( gates.filter(gate => ( gate.id === idGate ) ) );

		if(objGate) {
			dispatch({ type: 'DELETE_CD_GATE', payload: {
				gate: objGate[0],
				cdId: cdId
			} });
		}
	}

	const changeGate = (objGate) => {
		dispatch({
			type: "SET_CD_GATE_MODAL",
			payload: {...objGate, idCd: cdId }
		});
	}

	const selectGate = (id, nome) => {
		dispatch({
			type: "GET_LAST_DATE"
		});

		dispatch({
			type: "GATE_SELECT",
			nome: nome,
			id: id
		});

		dispatch({
			type: "GET_GATE_VARIATION",
			id: id
		});

		setModalVariations(true)
	}

	const closeModal = () => {
		dispatch({
			type: "GATE_VARIATION_CLEAN",
		});

		setModalVariations(false)
	}

	return (
		<div className="cd-gates">
			<Container className="extra-rounded-top extra-rounded-bottom bg-color-primary container-cd-gates">
				<Row className="px-2">
					<Col className="text-left py-2">
						<span className="text-3 font-weight-bold">{messages[lang].gates}</span>
					</Col>
				</Row>
				<hr className="custom-hr-style-1 pb-4" />

				<div className="cd-gates-body mb-2 ">
					{gates.map((gate) => {
						return (
							<Container key={gate.id} className="py-1">
								<Row className="text-center">
									<Col xs={8} className="bg-color-secondary border-right py-2 text-left">
										<span className="text-2 text-color-tertiary">
											<OverlayTrigger
													placement="top"
													delay={{ show: 250, hide: 400 }}
													overlay={
													<Tooltip>
															{gate.nome}
													</Tooltip>
											}>
													<span> {lodashTruncate(gate.nome, 24)} </span>
											</OverlayTrigger>
										</span>
									</Col>
									<Col xs={1}>
										<button
											className="btn-pen"
											id="reconcile_remove_file_button"
											onClick={() => editGate(gate.id)}
										>
											<i className="icon-pen" />
										</button>
									</Col>
									<Col xs={1}>
										<button
											className="btn-pen btn-remove"
											id="reconcile_remove_file_button"
											onClick={() => deleteGate(gate.id)}
										>
											<i className="icon-remove" />
										</button>
									</Col>
									<Col xs={2}>
										<ButtonStandard
											text={messages[lang].variations}
											textClass="text-1"
											className="btn-primary btn-sm btn-standard btn-variations"
											onClick={() => selectGate(gate.id, gate.nome)}
										/>
									</Col>
								</Row>
							</Container>
						)
					})
				}{
					(cdGateModal && cdGateModal.horarios) ?
						<CdGateModal
							show={modalShowGate}
							onHide={() =>{ setModalShowGate(false)}}
							gate={cdGateModal}
							name={cdGateModal.nome}
							title={messages[lang].editGate}
							type={"edit"}
						/>
					:
					<></>
					} {
					(modalVariations) ?
						<VariationsModal
							show={modalVariations}
							onHide={() => { closeModal()}}
							/>
							:
							<></>
				}
				</div>
			</Container>
		</div>
	);
}

export default CdGates;
